import { render } from "./StandbyCheckEditor.vue?vue&type=template&id=52a10da2&ts=true"
import script from "./StandbyCheckEditor.vue?vue&type=script&lang=ts"
export * from "./StandbyCheckEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__